// Which approval step a leave is waiting at in the two-level flow:
// Level 1 = reporting manager, Level 2 = HR. Amended leaves track their own
// new_* approvals. Mirrors pendingLevel() in the backend reminder handler.
const isSet = (value) => !!value && value !== "null";

export const getPendingApprovalLevel = (record) => {
  const isAmended =
    record?.having_cancel_request === "1" || record?.having_cancel_request === 1;
  const status = String(record?.status_id ?? "");

  if (isAmended) {
    if (!isSet(record?.new_approved_rejected_byName)) return 1;
    if (!isSet(record?.new_approved_rejected_by_higherofficials)) return 2;
    return null;
  }
  if (status === "4") {
    return isSet(record?.approved_rejected_byName) ? 2 : 1;
  }
  return null;
};

export const getPendingApprovalLabel = (record, t = (s) => s) => {
  const level = getPendingApprovalLevel(record);
  if (level === 1) {
    const manager = record?.reporting_manager_name;
    return `${t("Level 1 - Reporting Manager")}${manager ? ` (${manager})` : ""}`;
  }
  if (level === 2) return t("Level 2 - HR");
  return "-";
};
